import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import firebase from 'firebase/app'
import 'firebase/firestore'
firebase.initializeApp({
  apiKey: "AIzaSyD_yG_a1Hcxgv99O-97rD8M_HJLkSbu7yI",
  authDomain: "bf-web-2192b.firebaseapp.com",
  databaseURL: "https://bf-web-2192b.firebaseio.com",
  projectId: "bf-web-2192b",
  storageBucket: "bf-web-2192b.appspot.com",
  messagingSenderId: "568533941877",
  appId: "1:568533941877:web:3d9707e66f279d254c023c",
  measurementId: "G-G4312SDS70"
})

export const db = firebase.firestore()

